const DEFAULT_YA_METRICS_COUNTER = "yaCounter45878149";
const MAILRU_COUNTER_ID = "3151108";
const AGREEMENT_PACKAGES = {
  FREE: "free",
  BASE: "base",
  DRAFT: "draft",
  UNLIMITED: "unlimited"
};
const AGREEMENT_TYPE = {
  EXCLUSIVE: "exclusive",
  NON_EXCLUSIVE: "non_exclusive",
  NON_EXCLUSIVE_DRAFT: "non_exclusive_draft"
};
const COMMUNICATION_PACKAGE_TYPE = {
  [AGREEMENT_PACKAGES.DRAFT]: AGREEMENT_TYPE.NON_EXCLUSIVE_DRAFT,
  [AGREEMENT_PACKAGES.FREE]: AGREEMENT_TYPE.NON_EXCLUSIVE,
  [AGREEMENT_PACKAGES.BASE]: AGREEMENT_TYPE.NON_EXCLUSIVE,
  [AGREEMENT_PACKAGES.UNLIMITED]: AGREEMENT_TYPE.EXCLUSIVE
};
/**
 * Book states used in visual display
 */

const BOOK_STATUS = {
  REAL_DRAFT: "real_draft",
  FILE_ERROR: "file_error",
  CONVERTING_ERROR: "converting_error",
  VALIDATION_ERROR: "validation_error",
  CONVERTING: "converting",
  DRAFT: "draft",
  IN_PROGRESS: "in_progress",
  REJECTED: "rejected",
  REMOTE_PUBLISHED: "remote_published",
  REMOTE_PUBLISHED_PRINTED: "remote_published_printed",
  REMOTE_UNPUBLISHED: "remote_unpublished"
};
const BOOK_STATUSES_LOADED_WITH_ERROR = [BOOK_STATUS.CONVERTING_ERROR, BOOK_STATUS.VALIDATION_ERROR, BOOK_STATUS.FILE_ERROR];
const AUDIOBOOK_STATUS = {
  NOT_EXISTS: "NOT_EXISTS",
  PENDING: "PENDING",
  PRODUCTION: "PRODUCTION",
  PUBLISHED: "PUBLISHED",
  UNPUBLISHED: "UNPUBLISHED",
  CANCELED: "CANCELED"
};
const GENERATION_STATUS = {
  // Новый
  NEW: "NEW",
  // Конвертируется
  CONVERTING: "CONVERTING",
  // Ошибка при конвертации
  ERROR: "ERROR",
  // Ошибка валидации
  INVALID: "INVALID",
  // Обработано
  OK: "OK"
};
const PROFILE_STATUSES = {
  NEW: "NEW",
  UNVERIFIED: "UNVERIFIED",
  REJECTED: "REJECTED",
  SUBMITTED: "SUBMITTED"
};
const REFERRAL_STATUS = {
  UNDEFINED: "undefined",
  DISABLED: "DISABLED",
  OFFER: "OFFER",
  ACTIVE: "ACTIVE",
  PENDING: "PENDING"
};
const PADDING_TO_SCROLL_TO_ELEMENT = 10;
const MIN_PAGE_COUNT = 8;
const MAX_PAGE_COUNT = 850;
const INTERVAL_CHECK_PROCESSING_BOOK_STATUS = 3000;
export { DEFAULT_YA_METRICS_COUNTER, MAILRU_COUNTER_ID, AGREEMENT_PACKAGES, AGREEMENT_TYPE, COMMUNICATION_PACKAGE_TYPE, BOOK_STATUS, BOOK_STATUSES_LOADED_WITH_ERROR, AUDIOBOOK_STATUS, GENERATION_STATUS, PROFILE_STATUSES, REFERRAL_STATUS, PADDING_TO_SCROLL_TO_ELEMENT, MIN_PAGE_COUNT, MAX_PAGE_COUNT, INTERVAL_CHECK_PROCESSING_BOOK_STATUS };